import { useContext, useEffect, useState } from "react";
import delete_img from '../images/icon-cross.svg';
import { DataList } from '../context/Datalist';
import Getdata from '../functions/getdata';
import Items from "./Items";
import Option from "./Option";
import { Edit_context } from "../context/Edited-context";
export default function Items_todo({theme,inp_todo}) {
    let result_data = useContext(DataList);
    let {Edited,setEdited} = useContext(Edit_context);
    let [opt,setOpt] = useState('All');
    let [ShowRes,setShow] = useState([]);
    useEffect(_ => {
        result_data.setData(Getdata());
    },[])
    useEffect(_ => {
        let result;
        if(opt == 'All') {
             result =  result_data.Data.map(el =>  <Items id_el={el.id} value={el.value} delete_img={delete_img} key={el.id} complete = {el.complete} inp_todo = {inp_todo} />);
        }else if(opt == 'Active') {
            result =  result_data.Data.filter(el => !el.complete).map(el => <Items id_el={el.id} value={el.value} delete_img={delete_img} key={el.id} complete = {el.complete} inp_todo = {inp_todo} />);
        }else if(opt == 'Completed') {
            result =  result_data.Data.filter(el => el.complete).map(el => <Items id_el={el.id} value={el.value} delete_img={delete_img} key={el.id} complete = {el.complete} inp_todo = {inp_todo} />);
        }
        setShow(result)    
    },[opt,result_data.Data])
        return (
           <>
             <div className={`lists_items_box ${theme === 'dark' ? 'dark' : ''}`}>
                <ul>
                    {ShowRes.length == 0 ? <li style={{justifyContent:'center',fontSize:'18px'}}>No Item Found !</li> : ShowRes}
                </ul>
                <Option result_data = {result_data} opt = {opt} setOpt = {setOpt}/>
            </div>
            <a href="https://github.com/Youssef-Ghafir" target="_blank" style={{textDecoration:'none'}}><p className="cr">Created By YG</p></a>
           </>

     )
}
